import { Control } from 'runtime/controls/control';

export class ValidateRequested {
    static eventName() { return 'ValidateRequested'; }

    eventName = ValidateRequested.eventName;

    context: Control;
    ruleName: string;

    constructor(context?: Control, ruleName?: string) {
        this.context = context;
        this.ruleName = ruleName;
    }
}
